import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import AskMaterialRow from './AskMaterialRow';

import FormCreateOrViewAskMaterial from './FormCreateOrViewAskMaterial';
import { updateSite, refreshReferential } from '../../app/updateApp';

import noSupply from '../../../assets/no-supply.png';

const AskMaterial = () => {
    const { t } = useTranslation();

    useEffect(function () {
        refreshReferential().then(() => updateSite(siteState.selectedSite));
    }, []);

    const [popupOpen, setPopupOpen] = React.useState(false);
    const [askMaterialShown, setAskMaterialShown] = React.useState(null);
    const siteState = useSelector(state => state.sites);

    const selectedSite = siteState.list.find(s =>
        s.id === siteState.selectedSite
    );

    const showNoData = selectedSite.ask_materials.length === 0;
    const askMaterialInProgress = selectedSite.ask_materials.filter(s => s.sent === 0);
    const askMaterialSent = selectedSite.ask_materials.filter(s => s.sent === 1);

    return (
        <div className="module-subpage module-supply module-ask-material">
            { showNoData &&
                <div className="no-supply">
                    <img src={noSupply} />
                </div>
            }
            <div className="supplies">
                { (askMaterialInProgress.length > 0) && <div className="previous_label"> { t('app:current_ask_material') } : </div> }
                {
                    askMaterialInProgress.sort((a, b) => {
                        return new Date(b.date) - new Date(a.date);
                    }).map(s =>
                        <AskMaterialRow
                            key={s.id}
                            open={() => {
                                setAskMaterialShown(s);
                                setPopupOpen(true);
                            }}
                            supply={s}
                        />
                    )
                }
                { (askMaterialSent.length > 0) && <div className="previous_label"> { t('app:previous_ask_material') } : </div> }
                {
                    askMaterialSent.sort((a, b) => {
                        return new Date(b.date) - new Date(a.date);
                    }).map(s =>
                        <AskMaterialRow
                            key={s.id}
                            open={() => {
                                setAskMaterialShown(s);
                                setPopupOpen(true);
                            }}
                            supply={s}
                        />
                    )
                }
            </div>
            <FormCreateOrViewAskMaterial
                onClose={() => setPopupOpen(false)}
                opened={popupOpen}
                askMaterial={askMaterialShown}
            />
        </div>
    );
};

export default AskMaterial;
